<template>
    <div class="min-h-screen flex">
        <div @click="showHelp=true">
            <help-button />
        </div>

        <help :show-help="showHelp" @close="showHelp = false"  />

        <div class="hidden lg:block w-1/4 bg-white h-screen">
            <router-link :to="{name:'Login'}" class="flex items-center mt-16 ml-16">
                <icon name="logo-neopass" class="text-indigo-600"/>
            </router-link>

            <illustration class="absolute my-auto inset-0 px-8 py-2 w-1/4" name="check_validation" />
        </div>
        <div class="flex-1 flex flex-col w-3/4 bg-gray-200 rounded-tl-large justify-center py-12 px-4 sm:px-6 lg:flex-none lg:pl-20 xl:pl-24">
            <div class="mx-auto lg:ml-32 w-full max-w-lg">
                <h1 class="text-left text-4xl font-normal leading-8 text-gray-900">
                    Mot de passe perdu
                </h1>
                <p class="mt-4 text-base font-normal text-gray-600">
                    Veuillez saisir votre adresse mail.
                </p>
                <p class="text-base font-normal text-gray-600">
                    Un lien de réinitialisation vous sera envoyé.
                </p>
                <div class="mt-5">
                    <form action="#" @submit.prevent="requestResetPassword">
                        <div class="rounded-md shadow-sm">
                            <input-text
                                id="email"
                                type="email"
                                name="email"
                                libelle=""
                                :value="form.email" @input="(newValue) => {form.email = newValue}"
                                :big="true"
                                placeholder="Adresse Email"
                                :required="true"
                            />
                        </div>

                        <div class="mt-8 space-y-4 flex flex-col items-center sm:space-y-0 sm:flex-row">
                            <big-action-button
                                border-color="border-transparent"
                                text-color="text-white"
                                bg-color="bg-pink-600"
                                bg-color-square="bg-pink-600"
                                icon-color="text-white"
                                libelle="CONTINUER"
                                :spinner="loading"
                                :right="true"
                                icon="arrow-right_1"
                                type-shadow="shadow-pink"
                            />
                        </div>

                        <p v-if="success" class="mt-6 text-xs font-medium text-green-600">
                            {{ success }}
                        </p>
                        <v-errors
                            :errors="{ ...errors }"
                            class="mt-6 text-xs font-medium text-red-500"
                        />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelpButton from '../../components/HelpButton';
import Help from './popup/Help';
import BigActionButton from './../../components/BigActionButton';
import { mapActions } from 'vuex';
import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';
import InputText from '../../components/Inputs/InputText';

export default {
  name: 'ForgotPassword',
    
  components: {
    HelpButton,
    Icon,
    Illustration,
    InputText,
    BigActionButton,
    Help,
  },

  data() {
    return {
      form: {
        email: ''
      },
      loading: false,
      errors: null,
      success: null,
      showHelp: false,
    };
  },

  methods: {
    ...mapActions({
      RequestResetPasswordAction: 'auth/request_reset_password'
    }),

    async requestResetPassword() {
      this.loading = true;
      this.errors = null;
      this.success = null;
      try {
        await this.RequestResetPasswordAction(this.form);
        this.success = 'Nous vous avons envoyé par email le lien de réinitialisation du mot de passe !';
      } catch (error) {
        this.errors = error.response.data.errors;
      }
      this.loading = false;
    }
  }
};
</script>
